import { useEffect, useState } from "react";
import { getCachedSplits, fetchSplits, subscribeSplits } from "@/lib/splitsConfig";

export function useSplits() {
  const [splits, setSplits] = useState(getCachedSplits());
  useEffect(() => {
    fetchSplits();
    const unsub = subscribeSplits(setSplits);
    return () => { unsub(); };
  }, []);
  return splits;
}
